<template>
  <div class="conference" >

  <div  v-if="item && user" class="conference-body">
          <vue-jitsi-meet
                ref="jitsiRef"
                domain="jitsi.avtest.uz"
                :options="jitsiOptions"
      ></vue-jitsi-meet>
  </div>
  
  </div>
</template>

<script>
import { cardUpdateResource, cardContentResource } from "@/plugins/functions";

import {mapState} from 'vuex';
export default {
  data: () => ({
    done:false,
    fields: [
      {
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
        readonly: false,
      },
      {
        key: "is_active",
        label: "Активен",
        type: "checkbox",
        textType: "text",
        readonly: false,
      },
      {
        key: "start_at",
        label: "Начало",
        type: "datetime",
        textType: "text",
        readonly: false,
      },
      {
        key: "unit",
        label: "Unit",
        type: "field",
        textType: "text",
        readonly: false,
      }
    ],
  }),

  props: ["item","close"],

  methods: {

    onIFrameLoad(){
        this.$refs.jitsiRef.addEventListener('readyToClose', this.readyToClose);
    },
    readyToClose(){
            this.close();
            let query = Object.assign({}, this.$route.query);
            if (query['item_conference']) {
              delete query['item_conference'];
            } else {
              return false;
            }
            this.$router.replace({ query });
    }
  },

 destroyed(){
 
  },
  computed: {
    ...mapState(['user']),
    jitsiOptions () {

      return {
        roomName: this.item.unit,
        noSSL: false,
        userInfo: {
          email: this.user.email,
          displayName: this.user.full_name,
        },
        configOverwrite: {
          enableNoisyMicDetection: false,
          defaultLanguage:'ru'
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
          SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          DEFAULT_LOCAL_DISPLAY_NAME: 'Вы',
            TOOLBAR_BUTTONS: [
                'microphone', 'camera',  'settings', 
                'hangup'
              ] 
        },
      onload: this.onIFrameLoad,

      };
    },
  },
};
</script>
<style lang="scss">
.conference {
  position:relative;
  &-body {
 
    width:100%;
    height: calc(100vh - 360px);
    background:#222;

    oveflow:hidden;
  }
}

</style>
